
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { TopicItemProps } from ".";
import { loading, create } from "store/topic";

interface ApiTopicCreateInputProps extends Omit<TopicItemProps, "id"> {
}

type ApiTopicCreateOutputProps = OutputBaseProps<{ item: TopicItemProps; }, ApiTopicCreateInputProps>;

export const apiTopicCreate = async (data: ApiTopicCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiTopicCreateOutputProps>("/api/topic/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
    }
    return res;
};